import { OrganizationTeamResponseDto } from 'app/API';

export const sortTeamsByName = (teams: OrganizationTeamResponseDto[] | undefined) =>
  [...(teams || [])].sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
